class LandingNavbar extends HTMLElement {
  connectedCallback() {
    this.menuButton = this.querySelector('[data-menu-toggle]');
    this.mobileMenu = this.querySelector('[data-mobile-menu]');
    this.megaDetails = Array.from(this.querySelectorAll('.landing-header__mega'));

    this.toggleMenu = this.toggleMenu.bind(this);
    this.onMenuClick = this.onMenuClick.bind(this);
    this.onDocumentClick = this.onDocumentClick.bind(this);
    this.onKeydown = this.onKeydown.bind(this);

    this.menuButton?.addEventListener('click', this.toggleMenu);
    this.mobileMenu?.addEventListener('click', this.onMenuClick);

    if (this.megaDetails.length) {
      document.addEventListener('click', this.onDocumentClick);
      document.addEventListener('keydown', this.onKeydown);
    }
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.onDocumentClick);
    document.removeEventListener('keydown', this.onKeydown);
  }

  toggleMenu() {
    const isOpen = this.classList.toggle('is-open');
    this.menuButton?.setAttribute('aria-expanded', String(isOpen));
    document.body.style.overflow = isOpen ? 'hidden' : '';
  }

  closeMenu() {
    this.classList.remove('is-open');
    this.menuButton?.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  onMenuClick(event) {
    const link = event.target.closest('a');
    if (link && !link.closest('summary')) {
      this.closeMenu();
    }
  }

  closeAllMega() {
    this.megaDetails.forEach((d) => d.removeAttribute('open'));
  }

  onDocumentClick(event) {
    const insideMega = event.target.closest('.landing-header__mega');
    if (!insideMega) {
      this.closeAllMega();
      return;
    }
    this.megaDetails.forEach((d) => {
      if (d !== insideMega) d.removeAttribute('open');
    });
  }

  onKeydown(event) {
    if (event.key === 'Escape') {
      this.closeAllMega();
      if (this.classList.contains('is-open')) this.closeMenu();
    }
  }
}

if (!customElements.get('landing-navbar')) {
  customElements.define('landing-navbar', LandingNavbar);
}
